<script>
import { Line, mixins } from "vue-chartjs";
import { getRandomColor } from "../../src/base";
import { lavalinkInfo } from "../base";


export default {
  extends: Line,
  mixins: [mixins.reactiveData],
  data() {
    return {
      chartData: "",
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: true,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return `Memory usage: ${value} MB`;
            },
          },
        },
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  async created() {
    await lavalinkInfo()
      .then((response) => {
        let dateData = response.map((item) => {
          return item.date;
        });

        let dataMemory = response.map((item) => {
          return parseFloat(item.memory.replace(" MB", ""));
        });

        const color_y = getRandomColor();

        this.chartData = {
          labels: dateData,
          datasets: [
            {
              label: "MEMORY USAGE",
              backgroundColor: getRandomColor(),
              borderWidth: 4,
              pointBorderColor: color_y,
              data: dataMemory,
            },
          ],
        };

        this.chartOptions = {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
                gridLines: {
                  display: true,
                },
              },
            ],
            xAxes: [
              {
                gridLines: {
                  display: false,
                },
              },
            ],
          },
          legend: {
            display: true,
          },
          responsive: true,
          maintainAspectRatio: false,
        };
      })
      .catch((e) => {
        this.errors.push(e);
      });
  },
};
</script>
